import { ApiResponse, RequestFailure } from '@owl-nest/api-client'
import * as api from '@owl-nest/api-client/latest'
import { PromiseAction } from '@owl-nest/redux-wrapper'
import { RootState } from '../reducers'
import { ExtraFields } from '../public/models/supporter'

export enum ACTION_TYPE {
  LOAD_SUPPORTERS_REQUEST = 'LOAD_SUPPORTERS_REQUEST',
  LOAD_SUPPORTERS_SUCCESS = 'LOAD_SUPPORTERS_SUCCESS',
  LOAD_SUPPORTERS_FAILURE = 'LOAD_SUPPORTERS_FAILURE',
}

type LoadSupporterFailure = { type: ACTION_TYPE.LOAD_SUPPORTERS_FAILURE; failure: RequestFailure }
type LoadSupporterRequest = { type: ACTION_TYPE.LOAD_SUPPORTERS_REQUEST }
type LoadSupporterSuccess = {
  type: ACTION_TYPE.LOAD_SUPPORTERS_SUCCESS
  success: api.Pageable<api.SupporterList<ExtraFields>> & { forceClean: boolean }
}

type LoadConfig<EXTRA_FIELDS extends string> = {
  pagination?: string
  extraFields?: EXTRA_FIELDS[]
  forceClean?: boolean
}

export function loadProjectSupporters<EXTRA_FIELDS extends string = ''>(
  projectId: number,
  { pagination, extraFields = [], forceClean = false }: LoadConfig<EXTRA_FIELDS> = {},
): PromiseAction<RootState, ApiResponse<api.Pageable<api.SupporterList<EXTRA_FIELDS>> & { forceClean: boolean }>> {
  const search = pagination !== undefined ? new URLSearchParams(pagination.slice(1)) : new URLSearchParams()
  search.set('extra_fields', extraFields.join(','))

  return {
    types: [
      ACTION_TYPE.LOAD_SUPPORTERS_REQUEST,
      ACTION_TYPE.LOAD_SUPPORTERS_SUCCESS,
      ACTION_TYPE.LOAD_SUPPORTERS_FAILURE,
    ],
    promise: async (_, state) => {
      const response = await api.api.get.projectSupporter({
        urlParams: { projectId: projectId.toString() },
        getParams: search,
        withToken: state.user.identity.type === 'loggedin',
      })
      return response.next(
        (success) =>
          ({ ...success.body, forceClean } as api.Pageable<api.SupporterList<EXTRA_FIELDS>> & { forceClean: boolean }),
      )
    },
  }
}

export type SupporterAction = LoadSupporterRequest | LoadSupporterSuccess | LoadSupporterFailure
